// noinspection GraphQLUnresolvedReference

import { gql, GraphQLClient } from 'graphql-request'

import { AccessToken } from '../../../base/models/paramsModel'
import { MyGraphQlError } from '../../../base/services/GraphqlError'
import { FRAGMENT_ARTICULO_MONEDA } from '../interfaces/fragment'

const gqlQuery = gql`
  ${FRAGMENT_ARTICULO_MONEDA}
  mutation ARTICULO_MONEDA_ADICIONAL2_REGISTRO($codigoMoneda: Int!) {
    articuloMonedaAdicional2Registro(codigoMoneda: $codigoMoneda) {
      ...fields
    }
  }
`

/**
 * Registramos una nueva moneda adicional 2
 * @param codigoMoneda
 */
export const apiArticuloMonedaAdicional2Registro = async (
  codigoMoneda: number,
): Promise<any> => {
  try {
    const client = new GraphQLClient(import.meta.env.ISI_API_URL)
    const token = localStorage.getItem(AccessToken)
    // Set a single header
    client.setHeader('authorization', `Bearer ${token}`)
    const data: any = await client.request(gqlQuery, { codigoMoneda })
    return data.articuloMonedaAdicional2Registro
  } catch (e: any) {
    throw new MyGraphQlError(e)
  }
}
